import Block from '../../common.blocks/block'

export default class Media extends Block {
	static title = 'media'

	constructor($el) {
		super($el)

		this.videoContainer = this.$el.findElement('video-container')
		this.videoPlaceholder = this.videoContainer.find(
			'.media__video-placeholder',
		)

		if (this.videoContainer.length > 0) {
			setTimeout(() => {
				this.videoContainer.html(
					'<iframe title="Olsen" referrerPolicy="strict-origin-when-cross-origin" src="' +
						this.videoPlaceholder.data('iframeSrc') +
						'" frameborder="0" allowfullscreen></iframe>',
				)
			}, 2000)
		}
	}
}
